import { combineReducers } from "redux";

import address from "./slices/address";
import banks from "./slices/banks";
import agreements from "./slices/agreements";
import communicationInfo from "./slices/communicationInfo";
import companies from "./slices/companies";
import { default as contractDetails, default as contracts } from "./slices/contracts";
import images from "./slices/images";
import localizedContractTypes from "./slices/contracts";
import organizationUnits from "./slices/organizationUnits";
import settings from "./slices/settings";
import sidebar from "./slices/sidebar";
import statistics from "./slices/statistics";
import trainings from "./slices/trainings";
import workerDetails from "./slices/workerDetails";
import workflows from "./slices/workflows";
import competences from "./slices/competences";
import workDetails from "./slices/workDetails";
import fileStorage from "./slices/fileStorage";
import companyCalendars from "./slices/contracts";
import positionTypes from "./slices/positionTypes";
import remoteWorkTypes from "./slices/remoteWorkTypes";
import { default as managerTasks, default as tasks } from "./slices/tasks";
import virtualTeams from "./slices/virtualTeams";
import relatedPersons from "./slices/relatedPersons";
import candidateTasks from "./slices/candidateProcesses";
import identificationTypes from "./slices/identificationTypes";




export default combineReducers({
    agreements,
    address,
    banks,
    identificationTypes,
    relatedPersons,
    communicationInfo,
    companies,
    companyCalendars,
    contracts,
    contractDetails,
    images,
    candidateTasks,

    localizedContractTypes,
    organizationUnits,

    remoteWorkTypes,
    positionTypes,
    settings,
    sidebar,
    statistics,

    trainings,

    virtualTeams,
    workerDetails,
    workflows,
    competences,
    workDetails,
    fileStorage,
    tasks,
    managerTasks
});
